/**
 * @module store/promocodes/mutations
 *
 * @version 1.0.2
 * @copyright SBC 2019
 */


import * as types from '@/store/mutation-types';

/* eslint-disable no-param-reassign */
export default {
  /**
   * Mutation: Начало загрузки страницы с промокодами
   *
   * @since Version 1.0.2
   */
  [types.GET_PROMOCODES_ASYNC.PENDING](state) {
    state.isLoading = true;
  },


  /**
   * Mutation: Ошибка при загрузке старницы с промокодами
   *
   * @since Version 1.0.2
   */
  [types.GET_PROMOCODES_ASYNC.FAILURE](state) {
    state.isLoading = false;
  },


  /**
   * Mutation: Успешная загрзка страницы с промокодами
   *
   * @since Version 1.0.2
   */
  [types.GET_PROMOCODES_ASYNC.SUCCESS](state, { data, total }) {
    state.promocodes = data;
    state.total = total;
    state.isLoading = false;
  },
};
/* eslint-enable no-param-reassign */
